import { useEffect } from 'react';
import { Link, useMatch, useResolvedPath } from 'react-router-dom';
import TopBar from './TopBar';

//translate
import { useTranslation } from 'react-i18next';

const Header = () => {
  const { t } = useTranslation();

  function CustomLink({ children, to, ...props }) {
    let resolved = useResolvedPath(to);
    let match = useMatch({ path: resolved.pathname, end: true });

    return (
      <Link
        className={match && "active"}
        to={to}
        {...props}
      >
        {children}
      </Link>
    );
  }

  const funcs = () => {
    /**
     * Easy selector helper function
     */
    const select = (el, all = false) => {
      el = el.trim()
      if (all) {
        return [...document.querySelectorAll(el)]
      } else {
        return document.querySelector(el)
      }
    }

    /**
     * Easy event listener function
     */
    const on = (type, el, listener, all = false) => {
      let selectEl = select(el, all)
      if (selectEl) {
        if (all) {
          selectEl.forEach(e => e.addEventListener(type, listener))
        } else {
          selectEl.addEventListener(type, listener)
        }
      }
    }

    /**
     * Easy on scroll event listener 
     */
    const onscroll = (el, listener) => {
      el.addEventListener('scroll', listener)
    }

    /**
     * Scrolls to an element with header offset
     */
    const scrollto = (el) => {
      let header = select('#header')
      let offset = header.offsetHeight

      if (!header.classList.contains('header-scrolled')) {
        offset -= 16
      }

      let elementPos = select(el).offsetTop
      window.scrollTo({
        top: elementPos - offset,
        behavior: 'smooth'
      })
    }

    /**
     * Header fixed top on scroll
     */
    let selectHeader = select('#header')
    if (selectHeader) {
      let headerOffset = selectHeader.offsetTop
      let nextElement = selectHeader.nextElementSibling
      const headerFixed = () => {
        if ((headerOffset - window.scrollY) <= 0) {
          selectHeader.classList.add('fixed-top')
          nextElement.classList.add('scrolled-offset')
        } else {
          selectHeader.classList.remove('fixed-top')
          nextElement.classList.remove('scrolled-offset')
        }
      }
      window.addEventListener('load', headerFixed)
      onscroll(document, headerFixed)
    }

    /**
     * Back to top button
     */
    let backtotop = select('.back-to-top')
    if (backtotop) {
      const toggleBacktotop = () => {
        if (window.scrollY > 100) {
          backtotop.classList.add('active')
        } else {
          backtotop.classList.remove('active')
        }
      }
      window.addEventListener('load', toggleBacktotop)
      onscroll(document, toggleBacktotop)
    }

    /**
     * Mobile nav toggle
     */
    on('click', '.mobile-nav-toggle', function (e) {
      select('#navbar').classList.toggle('navbar-mobile')
      this.classList.toggle('bi-list')
      this.classList.toggle('bi-x')
    })

    /**
     * Mobile nav dropdowns activate
     */
    on('click', '.navbar .dropdown > a', function (e) {
      if (select('#navbar').classList.contains('navbar-mobile')) {
        e.preventDefault()
        this.nextElementSibling.classList.toggle('dropdown-active')
      }
    }, true)

    /**
     * Scrool with ofset on links with a class name .scrollto
     */
    on('click', '.scrollto', function (e) {
      if (select(this.hash)) {
        e.preventDefault()

        let navbar = select('#navbar')
        if (navbar.classList.contains('navbar-mobile')) {
          navbar.classList.remove('navbar-mobile')
          let navbarToggle = select('.mobile-nav-toggle')
          navbarToggle.classList.toggle('bi-list')
          navbarToggle.classList.toggle('bi-x')
        }
        scrollto(this.hash)
      }
    }, true)

    /**
     * Scroll with ofset on page load with hash links in the url
     */
    window.addEventListener('load', () => {
      if (window.location.hash) {
        if (select(window.location.hash)) {
          scrollto(window.location.hash)
        }
      }
    });

  }


  useEffect(() => {
    funcs()
  }, [])



  return (
    <>
      <TopBar />
      <header id="header" className="d-flex align-items-center">
        <div className="container d-flex justify-content-between align-items-center">

          <div className="logo">
            <Link to="/"><img src="assets/img/logo.png" alt="Kasab Kablo" className="img-fluid" /></Link>
          </div>

          <nav id="navbar" className="navbar">
            <ul>
              <li>
                <CustomLink to='/'>
                  {t("links.Home")}
                </CustomLink>
              </li>
              <li>
                <CustomLink to='/about'>
                  {t("links.AboutUs")}
                </CustomLink>
              </li>
              <li>
                <CustomLink to='/images'>
                  {t("links.Images")}
                </CustomLink>
              </li>
              <li>
                <CustomLink to='/products'>
                  {t("links.Products")}
                </CustomLink>
              </li>
              <li>
                <CustomLink to='/certificates'>
                  {t("links.Certificates")}
                </CustomLink>
              </li>
              <li>
                <CustomLink to='/contact'>
                  {t("links.Contact")}
                </CustomLink>
              </li>
              <li>
                <CustomLink className="catalogBtn" to='/catalog'>
                  {t("links.eCatalog")}
                </CustomLink>
              </li>
              {/* DROPLINK
              <li className="dropdown"><Link to="#"><span>Drop Down</span> <i className="bi bi-chevron-down"></i></Link>
              <ul>
                <li><Link to="#">Drop Down 1</Link></li>
                <li className="dropdown"><Link to="#"><span>Deep Drop Down</span> <i className="bi bi-chevron-right"></i></Link>
                  <ul>
                    <li><Link to="#">Deep Drop Down 1</Link></li>
                    <li><Link to="#">Deep Drop Down 2</Link></li>
                    <li><Link to="#">Deep Drop Down 3</Link></li>
                    <li><Link to="#">Deep Drop Down 4</Link></li>
                    <li><Link to="#">Deep Drop Down 5</Link></li>
                  </ul>
                </li>
                <li><Link to="#">Drop Down 2</Link></li>
                <li><Link to="#">Drop Down 3</Link></li>
                <li><Link to="#">Drop Down 4</Link></li>
              </ul>
            </li> */}
            </ul >
            <i className="bi bi-list mobile-nav-toggle"></i>
          </nav >

        </div >
      </header >
    </>
  );
}

export default Header;
